import JDFLogo from '../../assets/svg/Logo.svg';
import successCheckmark from '../../assets/svg/successCheckAnimation.svg';
import {getAPICall} from '../../services/apiCallsHandler';

import {CircularProgress, Button} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSearchParams, useNavigate} from 'react-router-dom';

import './ActivateEmail.css';

const ActivateEmail = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isVerifying, setIsVerifying] = React.useState(true);
  const [isVerified, setIsVerified] = React.useState(false);

  React.useEffect(() => {
    const token = searchParams.get('token');

    try {
      setIsVerifying(true);
      getAPICall(
        `activateEmail?token=${encodeURIComponent(token)}`,
        {
          errorTag: 'ACTIVATE_EMAIL',
          redirectToOops: false,
        },
        {}
      ).then((res) => {
        setIsVerifying(false);
        setIsVerified(res?.status === 200);
      });
    } catch (error) {
      setIsVerifying(false);
      setIsVerified(false);
    }
  }, []);

  return (
    <div className="activateEmailWrapper" data-testid="activateEmailWrapper">
      <div className="activateEmailHeading">
        <div className="jdf-logo">
          <img src={JDFLogo} alt="JDF Logo" />
        </div>
      </div>
      <div className="activateEmailContent">
        <div className="activateEmailContainer">
          {isVerifying ? (
            <div className="activateEmailStatus">
              <CircularProgress size="small" />
            </div>
          ) : (
            <div className="activateEmailStatus">
              {isVerified ? (
                <img
                  className="successCheckmark"
                  src={successCheckmark}
                  alt="Success"
                />
              ) : null}

              {isVerified ? (
                <div>
                  <p className="verified">{t('EMAIL_VERIFIED')}</p>
                  <p className="verifiedSubText">
                    {t('EMAIL_VERIFIED_SUBTEXT')}
                  </p>
                  <Button
                    type="submit"
                    disabled={false}
                    id="createAccountButton"
                    variant="primary"
                    onClick={() => navigate('/verification', {replace: true})}
                  >
                    {t('CREATE_YOUR_ACCOUNT')}
                  </Button>
                </div>
              ) : (
                t('EMAIL_VERIFICATION_FAILED')
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivateEmail;
